import './kitStyles';
import React from 'react';
import { Button, type ButtonProps } from './Button';
import type { IconName } from './icons';

/**
 * WEB-3310 юнит 1 — кнопка-значок кита, эталон `IconButton({ icon, label, size,
 * kind = 'ghost', ...rest })`: подпись — в `aria-label` и в `data-tip`. Подсказку
 * по `data-tip` показывает слой всплывающих (юнит 2а); до него виден только
 * атрибут.
 */
export interface IconButtonProps extends Omit<ButtonProps, 'icon' | 'children'> {
  icon: IconName;
  label: string;
}

export function IconButton({
  icon,
  label,
  size,
  kind = 'ghost',
  ...rest
}: IconButtonProps): React.ReactElement {
  return (
    <Button kind={kind} size={size} icon={icon} aria-label={label} data-tip={label} {...rest} />
  );
}
